import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "Temp_Quotation_Item"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

let fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: { width: "60px" }
    },
    { key: 'ItemTypeId', label: '物料类型', sortable: true, _hide: true },
    { key: 'ItemTypeName', label: '物料类型', sortable: true, thStyle: { width: "100px" } },
    { key: 'ItemName', label: '物料名称', sortable: true },
    { key: 'Spec', label: '规格', sortable: true, thStyle: { width: "12rem" } },
    { key: 'TEC_GoLength', label: '上机长mm', sortable: true, type: "just_number" },
    { key: 'TEC_GoWidth', label: '上机宽mm', sortable: true, type: "just_number" },
    { key: 'Mould_Count', label: '排版模数', sortable: true, type: "just_number" },
    { key: 'UseLength', label: '用料长mm', sortable: true, type: "just_number" },
    { key: 'UseWidth', label: '用料宽mm', sortable: true, type: "just_number" },
    { key: 'Cut_Count', label: '开数', sortable: true, type: "just_number" },
    { key: 'Unit_Use', label: '计量单位', sortable: true },
    {
      key: 'Unit_Price', label: '单位成本',
      type: "button",
      button: {
        type: "text",
        icon_class: "fa fa-eye-slash",
        label: "",
        show_label: true
      },
      thStyle: { width: "60px" },
    },
    { key: 'CostGroupId', label: '成本组', sortable: true },
    { key: 'Description', label: '备注', sortable: true, thStyle: { width: "812em" } }
  ]
}

const dataForm = {}

const validatePositive = (rule, value, callback) => {
  if (!value && value != 0) { // 空值（未填写）
    callback(new Error('请输入数值'))
  }
  if (typeof value !== 'number') {
    callback(new Error('请输入有效数字！'))
  }
  if (value < 0) { // 小于0
    callback(new Error('必须大于等于0！'))
  }
  else
    callback()
}
///前端验证
const rules = {
}

const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveData(params) {
    let _actions = []
    for (var k in params) {
      if (k == "add") {
        delete params[k].id
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.deleteAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, fields, methods, rules, validatePositive };

